import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Checkbox,
  ListItemText,
  ButtonGroup,
  Menu,
  FormHelperText
} from '@mui/material';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import DateRange from 'src/components/common/DateRange';
import BasicMenu from 'src/components/common/BasicMenu';
import { useEffect, useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';
import StatusCount from '../dashboard/StatusCount';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const EmployeeListToolbar = ({ statusCount, selectionData, loading, exportData, exportConfig, searchEmployees, removeStatusFilter, statusSelected, refreshData, ...props }) => {
  const handleDelete = () => {
    removeStatusFilter('removeStatus')
  }
  // const statusList = JSON.parse(JSON.stringify(masterStatus))
  const [searchField, setSearchField] = useState('')
  const [searchType, setSearchType] = useState('email')
  const [campLocation, setCampLocation] = useState([])
  const [providerName, setProviderName] = useState([])
  const [campType, setCampType] = useState([])
  const [dateRange, setDateRange] = useState([])
  const [status, setStatus] = useState('')
  const [exportType, setExportType] = useState('CSV');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = (item) => {
    setAnchorEl(null);
    if(item){
      setExportType(item.title)
    }
  };
  const totalStatusArr = statusCount.filter(data => data.statusName == 'Total')
  const totalCount = totalStatusArr[0] && totalStatusArr[0] ? totalStatusArr[0].totalCount : null

  useEffect(() => {
    setStatus(statusSelected)
  }, [statusSelected])

  const handleRefresh = (type) => {
    let obj = {}
    if (dateRange.length == 2) {
      obj.dateRange = dateRange
    }
    if (campLocation.length > 0) {
      obj.campLocation = campLocation
    }
    if (providerName.length > 0) {
      obj.providerName = providerName
    }
    if (campType.length > 0) {
      obj.campType = campType
    }
    if (status.length > 0) {
      obj.status = status
    }
    if(type === 'REFRESH') {
      refreshData(obj)
    } else if(type === 'EXPORT') {
      exportData(obj, exportType)
    }
  }

  const menuList = [{
    id: 'email',
    title: 'Email',
  }, {
    id: 'phoneNumber',
    title: 'Phone',
  }]

  const fileList = [{
    id: 'CSV',
    title: 'csv'
  }, {
    id: 'XLSX',
    title: 'xlsx'
  }]

  return (
    <Box {...props}>
        <Card elevation={0}>

          <CardContent className="display-align-center">
            <Grid
              container
              direction="column"
            >
              <Grid
                item
                container
                direction="row"
                alignItems="start"
                spacing={3}
              >
                <Grid
                  item
                  sm={3}
                  xs={12}
                >
                  <DateRange boxsize='small' onDateChange={(value) => setDateRange(value)} />
                </Grid>
                <Grid
                  item
                  sm={2}
                  xs={12}
                >
                  <FormControl size='small' fullWidth variant="outlined">
                    <InputLabel>Location</InputLabel>
                    <Select
                      multiple
                      value={campLocation}
                      onChange={(e) => setCampLocation(e.target.value)}
                      renderValue={(selected) => selected.join(', ')}
                      label="Location"
                    >
                      {(typeof selectionData.campLocation !== 'undefined') ? selectionData && selectionData.campLocation.length ? 
                      selectionData.campLocation.map((val, idx) => (
                        <MenuItem sx={{py: 0}} value={val} key={idx}>
                          <Checkbox
                            color="primary"
                            // icon={<RadioButtonUncheckedIcon/>}
                            // checkedIcon={<CheckCircleIcon/>}
                            size="small" checked={campLocation.indexOf(val) > -1} />
                          <ListItemText primary={val} />
                        </MenuItem>
                      )) : null : null}
                    </Select>
                    <FormHelperText>
                      &nbsp;
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  sm={2}
                  xs={12}
                >
                  <FormControl size='small' fullWidth variant="outlined">
                    <InputLabel>Provider</InputLabel>
                    <Select
                      multiple
                      value={providerName}
                      onChange={(e) => setProviderName(e.target.value)}
                      renderValue={(selected) => selected.join(', ')}
                      label="Provider"
                    >
                      {(typeof selectionData.providerName !== 'undefined') ? selectionData && selectionData.providerName.length ? 
                      selectionData.providerName.map((val, idx) => (
                        <MenuItem sx={{py: 0}} value={val} key={idx}>
                          <Checkbox
                            color="primary"
                            // icon={<RadioButtonUncheckedIcon/>}
                            // checkedIcon={<CheckCircleIcon/>}
                            size="small" checked={providerName.indexOf(val) > -1} />
                          <ListItemText primary={val} />
                        </MenuItem>
                      )) : null : null}
                    </Select>
                    <FormHelperText>
                      &nbsp;
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  sm={2}
                  xs={12}
                >
                  <FormControl size='small' fullWidth variant="outlined">
                    <InputLabel>Camp Type</InputLabel>
                    <Select
                      multiple
                      value={campType}
                      onChange={(e) => setCampType(e.target.value)}
                      renderValue={(selected) => selected.join(', ')}
                      label="Camp Type"
                    >
                      {(typeof selectionData.campType !== 'undefined') ? selectionData && selectionData.campType.length ? 
                      selectionData.campType.map((val, idx) => (
                        <MenuItem sx={{py: 0}} value={val} key={idx}>
                          <Checkbox
                            color="primary"
                            // icon={<RadioButtonUncheckedIcon/>}
                            // checkedIcon={<CheckCircleIcon/>}
                            size="small" checked={campType.indexOf(val) > -1} />
                          <ListItemText primary={val} />
                        </MenuItem>
                      )) : null : null}
                    </Select>
                    <FormHelperText>
                      &nbsp;
                    </FormHelperText>
                  </FormControl>
                </Grid>
                {/* <Grid item sm={2} xs={12}>
                  <FormControl size='small' variant="outlined" fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      labelId="city-select"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      label="Status"
                    >
                      <MenuItem value="">
                        <em>All</em>
                      </MenuItem>
                      {statusList.map((status, idx) => <MenuItem key={idx} value={status.status}>{status.status}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid> */}
                
                <Grid item>
                  <Tooltip title='Refresh'>
                    <IconButton size="small" sx={{boxShadow: '0 0 4px rgba(0,0,0,0.20)'}} onClick={() => handleRefresh('REFRESH')} color='primary' aria-label='refresh'> <Refresh /> </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid
                item
                mt={4}
                xs={12}
              >
                <Box className="display-align-center justify-space-between">
                  <Box sx={{ maxWidth: 1000, minWidth: 500 }} className='display-align-center'>
                    <FormControl size='small' variant="filled" fullWidth>
                      <OutlinedInput
                        id="outlined-search"
                        sx={{
                          boxShadow: 0,
                          bgcolor: '#f2f2f2'
                        }}
                        startAdornment={
                          <InputAdornment position="start">
                            <Box mb={2}>
                              <BasicMenu default={menuList[0]} list={menuList}
                                onMenuSelect={(value) => { setSearchType(value); setSearchField('') }} /></Box>
                          </InputAdornment>}
                        labelWidth={0}
                        value={searchField}
                        placeholder={`Search by ${searchType.toLowerCase()}`}
                        onChange={(ev) => setSearchField(ev.target.value)}
                      />
                    </FormControl>
                    <Button sx={{ ml:2, px: 3, boxShadow: '0 0 4px rgba(0,0,0,0.20)' }} color="primary" disabled={searchField.length < 3}
                      startIcon={<SearchIcon size="18"/>}
                      onClick={() => searchEmployees(searchType, searchField)}> Search</Button>
                  </Box>
                  <ButtonGroup variant="text" disabled={loading} sx={{boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15}}>
                    <Button sx={{ px: 2 }} onClick={() => handleRefresh('EXPORT')} 
                    startIcon={<ExportIcon size="18"/>}>
                      Export
                    </Button>
                    <Button onClick={(e)=> setAnchorEl(e.currentTarget)} endIcon={<ArrowDropDownIcon/>}>
                      {exportType}
                    </Button>
                  </ButtonGroup>
                </Box>
                <Menu
                  id="export-menu"
                  open={open}
                  anchorEl={anchorEl}
                  onClose={()=>handleClose()}
                  MenuListProps={{
                    'aria-labelledby': 'exporttypeMenu',
                  }}
                >
                  { fileList.map((menu) => 
                      <MenuItem key={menu.id} onClick={()=> handleClose(menu)}>{menu.title}</MenuItem>
                    ) }
                </Menu>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
    </Box>)
};
EmployeeListToolbar.propTypes = {
  searchEmployees: PropTypes.func,
  removeStatusFilter: PropTypes.func,
  statusSelected: PropTypes.string,
  exportConfig: PropTypes.object,
  selectionData: PropTypes.object,
  refreshData: PropTypes.func,
  exportData: PropTypes.func,
  loading: PropTypes.bool,
  statusCount: PropTypes.array
};
EmployeeListToolbar.defaultProps = {
  statusSelected: ''
}
export default EmployeeListToolbar;
